import React from "react";
import { Space, Tooltip } from "antd";
import ZohoLogo from "../../images/logos/zoho_crm.png";
import ParseLogo from "./images/parse.png";
import JiraLogo from "./images/jira.png";
import config from "../../api_config.json";
import { useAppContext } from "../../context";

const sizes = {
  small: 20,
  large: 30,
};

const linkStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '6px',
  backgroundColor: 'transparent',
  transition: 'all 0.2s ease',
  textDecoration: 'none',
};

const ServiceLink = ({ href, tooltip, logo, size, brandColor }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Tooltip title={tooltip} placement="top">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={href}
        style={{
          ...linkStyle,
          backgroundColor: isHovered ? `${brandColor}10` : 'transparent',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={logo}
          width={sizes[size]}
          alt={tooltip}
          style={{
            display: 'block',
            filter: isHovered ? 'brightness(1.1)' : 'brightness(1)',
            transition: 'filter 0.2s ease',
          }}
        />
      </a>
    </Tooltip>
  );
};

const UserLinks = (props) => {
  const { isProd } = useAppContext();
  const { user, size = "small", style } = props;

  if (!user || !user.objectId) {
    return <></>;
  }

  const parseDashboardUrl = `${config.parseDashboard[isProd ? "prod" : "dev"]}/browser/_User?filters=[{"field":"objectId","constraint":"eq","compareTo":"${user.objectId}"}]`;

  // Search by email or username in Zoho CRM
  const searchTerm = user.email || user.username || user.objectId;
  const zohoCrmUrl = `https://crm.zoho.eu/crm/org20108764695/search?searchword=${encodeURIComponent(searchTerm)}&isRelevance=false`;

  const jiraUrl = user.jira_id
    ? `https://onoranzefunebricloud.atlassian.net/jira/servicedesk/projects/SC/customers/${user.jira_id}`
    : null;

  return (
    <Space direction="horizontal" size={4} style={style}>
      <ServiceLink
        href={zohoCrmUrl}
        tooltip="Cerca in Zoho CRM"
        logo={ZohoLogo}
        size={size}
        brandColor="#ff7a59"
      />

      <ServiceLink
        href={parseDashboardUrl}
        tooltip="Visualizza in Parse Dashboard"
        logo={ParseLogo}
        size={size}
        brandColor="#169cee"
      />

      {jiraUrl && (
        <ServiceLink
          href={jiraUrl}
          tooltip="Visualizza in Jira Service Desk"
          logo={JiraLogo}
          size={size}
          brandColor="#0052cc"
        />
      )}
    </Space>
  );
};

export default UserLinks;
